import styled from 'styled-components';

const StylesModal=styled.div
` 
	color:black;

	*:not(#title)
	{
		font-size:4.5vh;
	}
`;

export default StylesModal;